/**
 * Required - explicitly import Ably BEFORE echo, otherwise
 * we run into Ably is not defined error as Laravel Echo
 * expects it to be a globally defined variable.
 */
import Echo from '@ably/laravel-echo'
import 'env'
import {api} from 'lib/url'
import * as Ably from 'ably'

if (typeof window !== 'undefined') {
  // @ts-ignore
  window.Ably = Ably // make globally accessible to Echo (https://github.com/ably-forks/laravel-echo)
}

/**
 * Create a private Laravel Echo instance that is authenticated
 * using the provided token.
 *
 * @param token
 * @returns
 */
export const createPrivate = (token: string) =>
  new Echo({
    broadcaster: 'ably',
    authEndpoint: api('/broadcasting/auth'),
    // Disable auto-connect to prevent ably from sending multiple connect requests
    // and then elevating channel access for private channels. This was resulting
    // in missing private channel capability errors. Turning this off makes
    // the behavior same as Pusher.
    autoConnect: false,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  })

export const createPublic = () =>
  new Echo({
    broadcaster: 'ably',
  })
